
// Definición de defaults

export const defaultAnexo: AnexoProps = {
    id:               0,
    idTipoAnexo:      0,
    tipoAnexo:        '',
    idTipoFormato:    0,
    tipoFormato:      '',
    cantidad:         0,
    numeroFojas:      0,
    observaciones:    '',    
}

// Creación de interface

export interface AnexoProps {
    id:               number;
    idTipoAnexo:      number;
    tipoAnexo:        string;
    idTipoFormato:    number;
    tipoFormato:      string;
    cantidad:         number;
    numeroFojas:      number;
    observaciones?:   string;
}